export const MAX_SCHEDULE_SIZE = 14;
